import { Link } from 'react-router-dom';
import type { Category } from '@/mocks/comics';

interface CategoryCardProps {
  category: Category;
  active?: boolean;
}

export default function CategoryCard({ category, active = false }: CategoryCardProps) {
  return (
    <Link
      to={`/category/${category.slug}`}
      className={`flex flex-col items-center gap-2 px-4 py-3 rounded-lg transition-all duration-300 cursor-pointer whitespace-nowrap ${
        active
          ? 'bg-primary-500 text-white'
          : 'bg-background-100 hover:bg-primary-100 text-foreground-700 hover:text-primary-600'
      }`}
    >
      <div className={`w-10 h-10 flex items-center justify-center rounded-full ${
        active ? 'bg-white/20' : 'bg-background-200'
      }`}>
        <i className={`${category.icon} text-lg`} />
      </div>
      <span className="text-xs font-medium">{category.name}</span>
      <span className={`text-[10px] ${active ? 'text-white/70' : 'text-foreground-400'}`}>
        {category.count}部
      </span>
    </Link>
  );
}